import { render } from "./milestone-cell.vue?vue&type=template&id=faaf4198&scoped=true&ts=true"
import script from "./milestone-cell.vue?vue&type=script&lang=ts"
export * from "./milestone-cell.vue?vue&type=script&lang=ts"

import "./milestone-cell.vue?vue&type=style&index=0&id=faaf4198&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faaf4198"]])

export default __exports__